export const gridStyle = {
  marginTop: '10px',
  '.MuiDataGrid-root, .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
  '.MuiDataGrid-toolbarContainer, .MuiDataGrid-columnHeaders, .MuiDataGrid-footerContainer':
    {
      backgroundColor: 'rgba(63,81,181,0.1)',
    },
  '.MuiDataGrid-columnHeaderTitle': {
    fontWeight: 700,
  },
};
